// src/components/BBS/StatusBar.js
import React, { useState, useEffect } from 'react';

export default function StatusBar() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const timeStr = time.toLocaleTimeString('en-US', { hour12: false });
  const dateStr = time.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return (
    <div className="bbs-status-bar">
      <span className="status-left">
        CONNECTED 2400 BAUD
      </span>
      <span className="status-center">
        OPHIDIA GLOBAL BBS v1.3
      </span>
      <span className="status-right">
        {dateStr} {timeStr}
      </span>
    </div>
  );
}